var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXendbridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4085"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3406",
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.517 22.3061C22.9409 21.8823 22.8415 21.172 22.3306 20.8586C21.2588 20.2008 20.299 19.502 19.3948 18.6585C18.4475 17.7748 17.5888 16.7581 16.7293 15.5085C16.3336 14.9332 15.4547 14.9598 15.0815 15.5499C14.4392 16.5656 13.7275 17.4709 12.8692 18.3149C11.9361 19.2326 10.8572 20.0508 9.55748 20.8549C9.04941 21.1692 8.95238 21.8772 9.37483 22.2996L14.4575 27.3823C15.2813 28.2061 16.617 28.2061 17.4409 27.3823L22.517 22.3061Z",
    fill: "#0747A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4444 4.61787C16.6206 3.79404 15.2849 3.79404 14.461 4.61787L4.61787 14.461C3.79404 15.2849 3.79404 16.6206 4.61787 17.4444L6.33104 19.1576C6.45525 19.2818 6.65315 19.2843 6.80712 19.1998C8.65539 18.1852 9.94579 17.271 10.96 16.2736C11.967 15.2833 12.7517 14.1617 13.5311 12.6732C14.5026 10.8177 17.1922 10.6825 18.3022 12.5124C19.4111 14.3404 20.3894 15.5794 21.446 16.565C22.5031 17.5512 23.6905 18.3327 25.2815 19.1967C25.4392 19.2823 25.6414 19.2798 25.7683 19.1529L27.3822 17.539C28.206 16.7152 28.206 15.3795 27.3822 14.5557L17.4444 4.61787Z",
    fill: "#4C9AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXendbridge);
export default __webpack_public_path__ + "static/media/xendbridge.69f29a3ddb09b4b24c58d60af2b6cd69.svg";
export { ForwardRef as ReactComponent };